import * as moment from 'moment';
import { useState } from 'react';
import { Utility } from '@nkr/services/utility';
import { IStrongBoxOpoFilter } from '@nkr/models/strong-box';
import { useAppHookContext } from '@nkr/utils/rest-api';
import useStrongBoxOpoPhysicalInventory from '@nkr/store/strong-box-opo/hooks/use-strong-box-opo-physical-inventory';
import StrongBoxFilter from '../strong-box/strong-box-filter';
import PhysicalInventoryGrid from '../strong-box/physical-inventory-grid';

const PhysicalInventoryOpo = () => {
    const { app: { user } } = useAppHookContext();
    
    const defaultFilter: IStrongBoxOpoFilter = {
        startDate: Utility.getFirstOfCurrentMonth(),
        // startDate: moment('2026-01-01').toDate(),
        endDate: Utility.getLastOfCurrentMonth(),
        isCenter: false,
        opoId: user.opoId == 0 ? null : user.opoId
    };

    const [filter, setFilter] = useState<IStrongBoxOpoFilter>(defaultFilter);
    const { list, loading, error, update } = useStrongBoxOpoPhysicalInventory(filter);

    return (
        <PhysicalInventoryGrid
            list={list}
            loading={loading}
            error={error}
            csvFileName='StrongBoxOpoPhysicalInventory.csv'
            emptyMessage='No OPO physical inventory records were found...'
            filterSlot={
                <StrongBoxFilter
                    filter={filter} 
                    defaultFilter={defaultFilter}
                    startDateLabel='Earliest Report Date'
                    endDateLabel='Latest Report Date'
                    isCenter={false}
                    onChange={setFilter}
                />
            }
            isCenter={false}
            onUpdate={update}
        />
    );
}

export default PhysicalInventoryOpo;
